import Axios from "axios"
import TokenService from "../utils/TokenService";
import router from "../router";
import store from "../store";

const baseURL = "https://dev.api.icangroup.uz/api/v1"
//const baseURL = "https://api.icangroup.uz/api/v1"  // PROD
 // const baseURL = "http://safo.loc/api/v1"
// const baseURL = 'http://127.0.0.1:8000/api/v1'
export const http = Axios.create({
  baseURL
})

function setConfiguration(provider) {
  provider.interceptors.request.use(config => {
      let token = TokenService.getToken();

      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      config.headers['Accept'] = 'application/json';
      config.headers['Content-Type'] = 'application/json';
      return config;
    },
    error => Promise.reject(error)
  );
  provider.interceptors.response.use(res => res,
    error => {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        TokenService.removeToken();
        TokenService.removeRefreshToken();
        store.commit('clearUser')
        store.dispatch('clearTimeIntervalRefreshToken')
          if(router.history.current.name !== 'login') {
            router.push({name: 'login'})
          }
      }
      return Promise.reject(error)
    });
}

setConfiguration(http)


export default http
